import type {
  TimelineUiOnlyViewSettings,
  TimelineViewSettings,
} from '../types';

export const toTimelineUiOnlyViewSettings = ({
  isLegendActive,
}: TimelineViewSettings): TimelineUiOnlyViewSettings => ({ isLegendActive });
